export default "__VITE_ASSET__ip4dnRQR__"